import React, { useEffect, useMemo, useState } from "react";
import "./styles/index.css"
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MediaSection from "./components/MediaSection";
import EventsSection from "./components/EventsSection";
import Footer from "./components/Footer";
import AboutSection from "./components/AboutSection";
import CoursesSection from "./components/CoursesSection";
import CoachsSection from "./components/CoachsSection";
import HorairesSection from "./components/HorairesSection";
import CeinturesSection from "./components/CeinturesSection";
import TarifsSection from "./components/TarifsSection";
import EnfantsSection from "./components/EnfantsSection";
import InscriptionSection from "./components/InscriptionSection";
import ContactSection from "./components/ContactSection";

/* ====== IMAGES ====== */
import img1 from "./assets/images/img-enfant.jpg";
import img2 from "./assets/images/img2.png";
import img3 from "./assets/images/img3.png";
import img4 from "./assets/images/img4.jpg";
import img5 from "./assets/images/img5.jpg";
import img6 from "./assets/images/img6.jpg";

import img36 from "./assets/images/img36group.jpg";
import img37 from "./assets/images/img37enfant.jpg";
import img38 from "./assets/images/img38enfant.jpg";
import img39 from "./assets/images/img39enfant.jpg";
import img47 from "./assets/images/img47.jpg";
import img15 from "./assets/images/img15.jpg";

import slider1 from "./assets/images/img_new2.jpeg";
import slider2 from "./assets/images/img_new3.jpeg";
import slider3 from "./assets/images/img_new4.png";
import slider4 from "./assets/images/img_new5.jpeg";
import slider5 from "./assets/images/photo_new9.png";
import slider6 from "./assets/images/img_new7.jpeg";

import spBelgium from "./assets/images/img30.webp";
import spAdepsFWB from "./assets/images/sponsors-adeps-fwb.jpg";
import spJudoWB from "./assets/images/sponsors-jwb.png";
import spKoekelberg from "./assets/images/sponsors-koekelberg.png";

import whatsappQR from "./assets/images/whatsapp-qr.jpg";
import photoMoub from "./assets/images/photoMoub.jpg";
import photoSaber from "./assets/images/photoSaber.jpg";

const googleFormLink =
  "https://docs.google.com/forms/d/e/1FAIpQLSfjBpIGuin_rE5dgUJe5iLKGNu6UFau6czZs1qwK2EnI5NqbA/viewform";

const social = {
  fb: "https://www.facebook.com/profile.php?id=61569611962233",
  ig: "https://instagram.com/wolvesbxl",
  tt: "https://www.tiktok.com/@wolvesbxl",
  wa: "https://wa.me/32488051685",
  mail: "mailto:wolvesbxl@hotmail.com",
};

const googleWriteReview =
  "https://www.google.com/search?sca_esv=fc0fadca8d161a09&rlz=1C1CHBD_en-GBBE1021BE1021&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E1jTyxlLZRO2nTY2yRZ6uSqUaSae8RtO4YLDkz022AxdCJ3xnts2IbNeZ0v9C421mo-Jo49uZmhHMDO-OuOazd0AhNIypkMD1a7WXj7V6-U2_W6NIQ%3D%3D&q=Wolves+Judo+Bruxelles+Reviews&sa=X&ved=2ahUKEwjks_qolM6PAxXeT6QEHVkhKtsQ0bkNegQIJBAD&biw=2133&bih=1050&dpr=0.9";

const headerSlides = [slider5, slider1, slider2, img15, slider3, slider4, slider6, slider5];
const GROUP_NUMBERS = [7, 11, 12, 13, 28];

const newImages = (() => {
  try {
    const ctx = require.context("./assets/images", false, /^\.\/img([7-9]|1\d|2[0-9]|5[1-9]|6[0-4])\.jpe?g$/i);
    return ctx.keys().map((k) => ({ src: ctx(k), name: k.replace("./", "") }));
  } catch {
    return [];
  }
})();

/* ====== SCROLL REVEAL HOOK ====== */
function useScrollReveal() {
  useEffect(() => {
    const elements = document.querySelectorAll("[data-reveal]");
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.10, rootMargin: "0px 0px -30px 0px" }
    );
    elements.forEach((el) => observer.observe(el));

    // Titres de section
    const titles = document.querySelectorAll(".section-title");
    const titleObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            titleObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );
    titles.forEach((el) => titleObserver.observe(el));

    return () => {
      observer.disconnect();
      titleObserver.disconnect();
    };
  }, []);
}

export default function App() {
  const [open, setOpen] = useState(false);
  const [fabOpen, setFabOpen] = useState(false);
  const [lightboxSrc, setLightboxSrc] = useState(null);
  const [mediaTab, setMediaTab] = useState("highlights");

  // Activer scroll reveals
  useScrollReveal();

  // lock scroll menu mobile
  useEffect(() => {
    const root = document.documentElement;
    const body = document.body;
    [root, body].forEach((el) => el.classList.toggle("menu-open", open));
    return () => [root, body].forEach((el) => el.classList.remove("menu-open"));
  }, [open]);

  // close FAB on ESC / outside click; close lightbox on ESC
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") {
        if (lightboxSrc) { setLightboxSrc(null); return; }
        setFabOpen(false);
      }
    };
    const onClick = (e) => {
      const el = document.querySelector(".quick-dock");
      if (fabOpen && el && !el.contains(e.target)) setFabOpen(false);
    };
    window.addEventListener("keydown", onKey);
    window.addEventListener("click", onClick);
    return () => {
      window.removeEventListener("keydown", onKey);
      window.removeEventListener("click", onClick);
    };
  }, [fabOpen, lightboxSrc]);

  const baseImages = useMemo(
    () => [
      { src: img1, name: "img1.png" },
      { src: img2, name: "img2.png" },
      { src: img3, name: "img3.png" },
      { src: img4, name: "img4.jpg" },
      { src: img5, name: "img5.jpg" },
      { src: img6, name: "img6.jpg" },
      { src: img36, name: "img36group.jpg" },
      { src: img47, name: "img47.jpg" },
      { src: img37, name: "img37enfant.jpg" },
      { src: img38, name: "img38enfant.jpg" },
      { src: img39, name: "img39enfant.jpg" },
    ],
    []
  );

  const GROUP_FILES = useMemo(
    () =>
      new Set([
        "img2.png",
        "img4.jpg",
        "img5.jpg",
        "img6.jpg",
        "img36group.jpg",
        "img37enfant.jpg",
        ...GROUP_NUMBERS.map((n) => `img${n}.jpg`),
      ]),
    []
  );

  const allImages = useMemo(() => [...newImages, ...baseImages], [baseImages]);

  const highlightImages = useMemo(
    () => allImages.filter((it) => !GROUP_FILES.has(it.name)).slice(0, 20),
    [allImages, GROUP_FILES]
  );

  const groupImages = useMemo(
    () => allImages.filter((it) => GROUP_FILES.has(it.name)),
    [allImages, GROUP_FILES]
  );

  return (
    <div className="App">
      <Navbar open={open} setOpen={setOpen} social={social} />

      <Hero headerSlides={headerSlides} social={social} />

      <main>
        <AboutSection />
        <CoursesSection />

        <MediaSection
          mediaTab={mediaTab}
          setMediaTab={setMediaTab}
          highlightImages={highlightImages}
          groupImages={groupImages}
          onOpenLightbox={setLightboxSrc}
          images={highlightImages}
          onOpen={setLightboxSrc}
        />

        <CoachsSection
          photoMoub={photoMoub}
          photoSaber={photoSaber}
          onOpenLightbox={setLightboxSrc}
        />

        <HorairesSection />
        <CeinturesSection />
        <EventsSection />

        <TarifsSection googleFormLink={googleFormLink} />

        <EnfantsSection img1={img1} />

        <InscriptionSection whatsappQR={whatsappQR} social={social} />

        <ContactSection social={social} />
      </main>

      <Footer
        googleWriteReview={googleWriteReview}
        sponsors={{ spBelgium, spAdepsFWB, spJudoWB, spKoekelberg }}
        social={social}
      />

      {/* Lightbox */}
      {lightboxSrc && (
        <div className="lightbox" role="dialog" aria-modal="true" aria-label="Visionneuse photo">
          <button className="lightbox-backdrop" onClick={() => setLightboxSrc(null)} aria-label="Fermer" />
          <img src={lightboxSrc} alt="" className="lightbox-img" />
          <button className="lightbox-close" onClick={() => setLightboxSrc(null)} aria-label="Fermer">
            <i className="fa-solid fa-xmark" />
          </button>
          <span className="lightbox-hint">ESC pour fermer</span>
        </div>
      )}

      {/* Dock flottant */}
      <div className={`quick-dock ${fabOpen ? "open" : ""}`} aria-live="polite">
        <button
          className="fab"
          aria-label={fabOpen ? "Fermer le menu d'actions rapides" : "Ouvrir le menu d'actions rapides"}
          aria-expanded={fabOpen}
          aria-controls="quick-dock-menu"
          onClick={(e) => {
            e.stopPropagation();
            setFabOpen((v) => !v);
          }}
        >
          <span className="fab-pulse" aria-hidden="true" />
          <i className={`fa-solid ${fabOpen ? "fa-xmark" : "fa-bolt"}`} />
        </button>

        <ul id="quick-dock-menu" className="fab-menu" role="menu">
          <li role="none">
            <a role="menuitem" href={social.wa} target="_blank" rel="noreferrer" aria-label="WhatsApp">
              <i className="fa-brands fa-whatsapp" />
              <span className="tip">WhatsApp</span>
            </a>
          </li>
          <li role="none">
            <a role="menuitem" href="tel:+32488051685" aria-label="Appeler">
              <i className="fa-solid fa-phone" />
              <span className="tip">Appeler</span>
            </a>
          </li>
          <li role="none">
            <a role="menuitem" href={social.mail} aria-label="Envoyer un email">
              <i className="fa-solid fa-envelope" />
              <span className="tip">Email</span>
            </a>
          </li>
          <li role="none">
            <a
              role="menuitem"
              href="https://www.google.com/maps?q=L%C3%A9on%20Autriquestraat%204%2C%201081%20Koekelberg%2C%20Belgi%C3%AB"
              target="_blank"
              rel="noreferrer"
              aria-label="Plan"
            >
              <i className="fa-solid fa-map-location-dot" />
              <span className="tip">Plan</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
